/* tslint:disable */
/* eslint-disable */
/**
 * chinaone-java
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { SenderCompanyVo } from './SenderCompanyVo';
import {
    SenderCompanyVoFromJSON,
    SenderCompanyVoFromJSONTyped,
    SenderCompanyVoToJSON,
    SenderCompanyVoToJSONTyped,
} from './SenderCompanyVo';
import type { OrderReceiveAddressVo } from './OrderReceiveAddressVo';
import {
    OrderReceiveAddressVoFromJSON,
    OrderReceiveAddressVoFromJSONTyped,
    OrderReceiveAddressVoToJSON,
    OrderReceiveAddressVoToJSONTyped,
} from './OrderReceiveAddressVo';
import type { ToKoreaWarehouseVo } from './ToKoreaWarehouseVo';
import {
    ToKoreaWarehouseVoFromJSON,
    ToKoreaWarehouseVoFromJSONTyped,
    ToKoreaWarehouseVoToJSON,
    ToKoreaWarehouseVoToJSONTyped,
} from './ToKoreaWarehouseVo';
import type { AddOrUpdateGoodsVo } from './AddOrUpdateGoodsVo';
import {
    AddOrUpdateGoodsVoFromJSON,
    AddOrUpdateGoodsVoFromJSONTyped,
    AddOrUpdateGoodsVoToJSON,
    AddOrUpdateGoodsVoToJSONTyped,
} from './AddOrUpdateGoodsVo';
import type { AdditionalServiceVo } from './AdditionalServiceVo';
import {
    AdditionalServiceVoFromJSON,
    AdditionalServiceVoFromJSONTyped,
    AdditionalServiceVoToJSON,
    AdditionalServiceVoToJSONTyped,
} from './AdditionalServiceVo';

/**
 * 
 * @export
 * @interface AddOrUpdateOrderReqVo
 */
export interface AddOrUpdateOrderReqVo {
    /**
     * 订单id，创建订单的时候，不传，更新订单的时候传
     * @type {number}
     * @memberof AddOrUpdateOrderReqVo
     */
    orderId?: number;
    /**
     * 订单类型 海外直购-电商快递-代买服务 1
     * 海外直购-电商快递-转运服务 2
     * 海外直购-海运物流-代买服务 3
     * 海外直购-海运物流-转运服务 4
     * 橙火入仓服务-中国购入-代买服务 5
     * 橙火入仓服务-中国购入-转运服务 6
     * 橙火入仓服务-韩国购入-转运服务 7
     * 3PL-中国3PL入库-中国库存代买入库 8
     * 3PL-中国3PL入库-中国库存转运入库 9
     * 3PL-韩国3PL入库-中国购入转运入库 10
     * 3PL-韩国3PL入库-中国购入代买入库 11
     * 3PL-韩国3PL入库-韩国购入转运入库 12
     * 3PL-韩国3PL出库-韩国库存出库 13
     * @type {number}
     * @memberof AddOrUpdateOrderReqVo
     */
    orderType?: number;
    /**
     * 是否临时存储 0 否 1 是
     * @type {number}
     * @memberof AddOrUpdateOrderReqVo
     */
    temp?: number;
    /**
     * 用户ID
     * @type {number}
     * @memberof AddOrUpdateOrderReqVo
     */
    userId?: number;
    /**
     * 中国仓库ID
     * @type {number}
     * @memberof AddOrUpdateOrderReqVo
     */
    chineseWarehouseId?: number;
    /**
     * 韩国仓库ID
     * @type {number}
     * @memberof AddOrUpdateOrderReqVo
     */
    koreaWarehouseId?: number;
    /**
     * 国际运输方式
     * @type {number}
     * @memberof AddOrUpdateOrderReqVo
     */
    internationalTransportMethodId?: number;
    /**
     * 韩国本土运输方式
     * @type {number}
     * @memberof AddOrUpdateOrderReqVo
     */
    koreaTransportMethodId?: number;
    /**
     * 结算方式 1 自动结算 2 手动结算
     * @type {number}
     * @memberof AddOrUpdateOrderReqVo
     */
    paymentType?: number;
    /**
     * 优惠券id，下单的时候，可以选择是否使用优惠券
     * @type {number}
     * @memberof AddOrUpdateOrderReqVo
     */
    prepayCouponId?: number;
    /**
     * 商品验收前确认要求项
     * @type {string}
     * @memberof AddOrUpdateOrderReqVo
     */
    requireBeforeAccept?: string;
    /**
     * 商品总数
     * @type {number}
     * @memberof AddOrUpdateOrderReqVo
     */
    goodsTotalQuantity?: number;
    /**
     * 商品总金额
     * @type {number}
     * @memberof AddOrUpdateOrderReqVo
     */
    goodsTotalAmount?: number;
    /**
     * 商品总金额  美元
     * @type {number}
     * @memberof AddOrUpdateOrderReqVo
     */
    goodsTotalAmountUsd?: number;
    /**
     * 基础包装项目  1 快递袋包装，2 装纸箱， 3 产品原包装
     * @type {number}
     * @memberof AddOrUpdateOrderReqVo
     */
    packingStorage?: number;
    /**
     * 返回订单处理方式 1废弃， 2韩国库存， 3 韩国快递件， 4 橙火入仓 一般快递，5 橙火入仓 官方揽收快递， 6橙火入仓 官方揽收托盘，7 待定
     * @type {number}
     * @memberof AddOrUpdateOrderReqVo
     */
    returnFromCoupangMethod?: number;
    /**
     * 如果当前订单是退货订单，这里记录要退货的订单id，如果是返送订单，这里记录送回的火箭订单id
     * @type {number}
     * @memberof AddOrUpdateOrderReqVo
     */
    returnOrderId?: number;
    /**
     * 取货方式  1 返送，2 自提
     * @type {number}
     * @memberof AddOrUpdateOrderReqVo
     */
    takeGoodsMethod?: number;
    /**
     * 
     * @type {OrderReceiveAddressVo}
     * @memberof AddOrUpdateOrderReqVo
     */
    receiveAddress?: OrderReceiveAddressVo;
    /**
     * 商品列表
     * @type {Array<AddOrUpdateGoodsVo>}
     * @memberof AddOrUpdateOrderReqVo
     */
    goods?: Array<AddOrUpdateGoodsVo>;
    /**
     * 附加服务列表
     * @type {Array<AdditionalServiceVo>}
     * @memberof AddOrUpdateOrderReqVo
     */
    additionalServices?: Array<AdditionalServiceVo>;
    /**
     * 
     * @type {ToKoreaWarehouseVo}
     * @memberof AddOrUpdateOrderReqVo
     */
    toKoreaWarehouse?: ToKoreaWarehouseVo;
    /**
     * 
     * @type {SenderCompanyVo}
     * @memberof AddOrUpdateOrderReqVo
     */
    senderCompany?: SenderCompanyVo;
}

/**
 * Check if a given object implements the AddOrUpdateOrderReqVo interface.
 */
export function instanceOfAddOrUpdateOrderReqVo(value: object): value is AddOrUpdateOrderReqVo {
    return true;
}

export function AddOrUpdateOrderReqVoFromJSON(json: any): AddOrUpdateOrderReqVo {
    return AddOrUpdateOrderReqVoFromJSONTyped(json, false);
}

export function AddOrUpdateOrderReqVoFromJSONTyped(json: any, ignoreDiscriminator: boolean): AddOrUpdateOrderReqVo {
    if (json == null) {
        return json;
    }
    return {
        
        'orderId': json['orderId'] == null ? undefined : json['orderId'],
        'orderType': json['orderType'] == null ? undefined : json['orderType'],
        'temp': json['temp'] == null ? undefined : json['temp'],
        'userId': json['userId'] == null ? undefined : json['userId'],
        'chineseWarehouseId': json['chineseWarehouseId'] == null ? undefined : json['chineseWarehouseId'],
        'koreaWarehouseId': json['koreaWarehouseId'] == null ? undefined : json['koreaWarehouseId'],
        'internationalTransportMethodId': json['internationalTransportMethodId'] == null ? undefined : json['internationalTransportMethodId'],
        'koreaTransportMethodId': json['koreaTransportMethodId'] == null ? undefined : json['koreaTransportMethodId'],
        'paymentType': json['paymentType'] == null ? undefined : json['paymentType'],
        'prepayCouponId': json['prepayCouponId'] == null ? undefined : json['prepayCouponId'],
        'requireBeforeAccept': json['requireBeforeAccept'] == null ? undefined : json['requireBeforeAccept'],
        'goodsTotalQuantity': json['goodsTotalQuantity'] == null ? undefined : json['goodsTotalQuantity'],
        'goodsTotalAmount': json['goodsTotalAmount'] == null ? undefined : json['goodsTotalAmount'],
        'goodsTotalAmountUsd': json['goodsTotalAmountUsd'] == null ? undefined : json['goodsTotalAmountUsd'],
        'packingStorage': json['packingStorage'] == null ? undefined : json['packingStorage'],
        'returnFromCoupangMethod': json['returnFromCoupangMethod'] == null ? undefined : json['returnFromCoupangMethod'],
        'returnOrderId': json['returnOrderId'] == null ? undefined : json['returnOrderId'],
        'takeGoodsMethod': json['takeGoodsMethod'] == null ? undefined : json['takeGoodsMethod'],
        'receiveAddress': json['receiveAddress'] == null ? undefined : OrderReceiveAddressVoFromJSON(json['receiveAddress']),
        'goods': json['goods'] == null ? undefined : ((json['goods'] as Array<any>).map(AddOrUpdateGoodsVoFromJSON)),
        'additionalServices': json['additionalServices'] == null ? undefined : ((json['additionalServices'] as Array<any>).map(AdditionalServiceVoFromJSON)),
        'toKoreaWarehouse': json['toKoreaWarehouse'] == null ? undefined : ToKoreaWarehouseVoFromJSON(json['toKoreaWarehouse']),
        'senderCompany': json['senderCompany'] == null ? undefined : SenderCompanyVoFromJSON(json['senderCompany']),
    };
}

export function AddOrUpdateOrderReqVoToJSON(json: any): AddOrUpdateOrderReqVo {
    return AddOrUpdateOrderReqVoToJSONTyped(json, false);
}

export function AddOrUpdateOrderReqVoToJSONTyped(value?: AddOrUpdateOrderReqVo | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'orderId': value['orderId'],
        'orderType': value['orderType'],
        'temp': value['temp'],
        'userId': value['userId'],
        'chineseWarehouseId': value['chineseWarehouseId'],
        'koreaWarehouseId': value['koreaWarehouseId'],
        'internationalTransportMethodId': value['internationalTransportMethodId'],
        'koreaTransportMethodId': value['koreaTransportMethodId'],
        'paymentType': value['paymentType'],
        'prepayCouponId': value['prepayCouponId'],
        'requireBeforeAccept': value['requireBeforeAccept'],
        'goodsTotalQuantity': value['goodsTotalQuantity'],
        'goodsTotalAmount': value['goodsTotalAmount'],
        'goodsTotalAmountUsd': value['goodsTotalAmountUsd'],
        'packingStorage': value['packingStorage'],
        'returnFromCoupangMethod': value['returnFromCoupangMethod'],
        'returnOrderId': value['returnOrderId'],
        'takeGoodsMethod': value['takeGoodsMethod'],
        'receiveAddress': OrderReceiveAddressVoToJSON(value['receiveAddress']),
        'goods': value['goods'] == null ? undefined : ((value['goods'] as Array<any>).map(AddOrUpdateGoodsVoToJSON)),
        'additionalServices': value['additionalServices'] == null ? undefined : ((value['additionalServices'] as Array<any>).map(AdditionalServiceVoToJSON)),
        'toKoreaWarehouse': ToKoreaWarehouseVoToJSON(value['toKoreaWarehouse']),
        'senderCompany': SenderCompanyVoToJSON(value['senderCompany']),
    };
}

